import React, { Component } from "react";

//Import Breadcrumb
import RCDisplayPage from "../../components/Common/RCDisplayPage";
//Constants
import { API_WEB_URLS } from "../../constants/constAPI";
//Store


import {
  Fn_FillListData,
  togglemodal,
  toggleDeleteConfirm,
  toggleDeleteSuccess,
  Fn_DeleteData,
  Fn_GetReport,
  Fn_AddEditData,
  Fn_ChangeStateValue,
  Fn_ExportExcel
} from "../../store/functions";

import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Input,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Button,
  Label,
  Alert,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Modal
} from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert"

import {
  AvForm,
  AvField,AvRadioGroup,AvRadio
} from "availity-reactstrap-validation";

import { compose } from "recompose";
import { container } from "../../store/Containers/cntCommon";

import Breadcrumbs from "../../components/Common/Breadcrumb";
import '../Masters/datatables.scss';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory, {
  PaginationProvider, PaginationListStandalone,
  SizePerPageDropdownStandalone
} from 'react-bootstrap-table2-paginator';
import { API_HELPER } from "helpers/ApiHelper";

import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import * as XLSX from 'xlsx';



function getCurrentDate() {
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
  const day = String(currentDate.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}
class pageList_FundRequest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      selectedFormData: {},
      gridData: [],
      confirm_alert: false,
      formData : {},
      success_msg: false,
      dynamic_title: "",
      dynamic_description: "",
      company : [],
      page: 1,
      sizePerPage: 10,
      productData: [],
      RReason : '',
      F_RetailerComission : 0,
      F_DistributorComission : 0,
      F_SDistributorComission : 0,
      F_MDistributorComission : 0,
      Charges : 0,
      commissionmodal : false,
      success_dlg : false,
      confirm_undorefund : false,
      title : '',
      UTR : '',
      loading : false,
      selectedIds: [] // Array to store selected IDs

    };
    this.obj = this;
    this.breadCrumbTitle = "Masters";
    this.breadCrumbItem = "Fund Transfer Report";
    this.modalTitle = "Audit Attendance";
    this.rtPage_Add = "add-customermaster";
    this.rtPage_Edit = "edit-customermaster";
    this.API_URL = "DMRTran/0/token";
    

    //Event Binding
    
    this.btnSave_onClick =  this.btnSave_onClick.bind(this);
   
   
    this.exportToExcel  = this.exportToExcel.bind(this);
    this.btnGoBack_onClick  = this.btnGoBack_onClick.bind(this);
    this.checkmerge =  this.checkmerge.bind(this);
    this.printmerge  = this.printmerge.bind(this);

  }

   
  exportToExcel = () => {

    // let vformData = new FormData();
    
    // vformData.append("FromDate", this.state.FromDate);
    // vformData.append("ToDate",  this.state.ToDate);
    
    // Fn_ExportExcel(this.obj, { arguList: { id: 0, formData: vformData } }, "DMRExcel/0/token", "DMRTransaction", true);
    
const obj = JSON.parse(sessionStorage.getItem("authUser"));



    const orderAndFilter = (arr) => {
    return arr.map((item) => {

  
       return {
        Id: item.Id,
        TransactionDate: item.TransactionDate,
        TransactionCode: item.TransactionCode,
        AccountHolderName: item.AccountHolderName,
        SenderMobileNo: item.SenderMobileNo,
        AccountNo: item.AccountNo,
        BankName: item.BankName,
        IFSC: item.IFSC,
        Mode: item.Mode,
        Amount: item.Amount,
        Charges: item.Charges,
        ChargeTaken: item.ChargeTaken
    }
    });
  };
  
  // Apply the order and filter function to your original array
  const orderedAndFilteredArray = orderAndFilter(this.state.productData);


    const worksheet = XLSX.utils.json_to_sheet(orderedAndFilteredArray);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'FundRequest');
    XLSX.writeFile(workbook, `FundRequest.xlsx`);


  };

 



  componentDidMount() {
   
   
  }


 


  btnSave_onClick (event, formData)  {

    this.setState({loading : true })

    
    const obj = JSON.parse(sessionStorage.getItem("authUser"));

    this.setState({FromDate : formData.FromDate ,ToDate : formData.ToDate })

    let vformData = new FormData();
   
    vformData.append("From", formData.FromDate);
    vformData.append("To", formData.ToDate);
   
    
    Fn_GetReport(this.obj, { arguList: { id: obj.uid, formData: vformData } }, this.API_URL, "productData", true);
    this.setState({loading : false })

  }


  btnGoBack_onClick = (Id) => {
   
    this.props.history.push("/printreceipt/"+Id);
  };

  printmerge(){
    const { selectedIds, productData } = this.state;
   

    // Filter productData based on selectedIds
    const filteredData = productData.filter((item) => selectedIds.includes(item.F_VoucherH));

    // Calculate the sum of amount and charges
    const total = filteredData.reduce(
      (acc, curr) => {
        acc.Amount += curr.Amount;
        return acc;
      },
      { Amount: 0 } // Initial values
    );

    const maxId = Math.max(...selectedIds);

    // Find the productData item with the maximum ID
    const maxItem = productData.find((item) => item.F_VoucherH === maxId);

    var arr  =  {
     
      number: 9762190890,
      
      
      date:maxItem.TransactionDate,
      receiptno:maxItem.ReceiptNo,
      name:maxItem.AccountHolderName,
      sender:maxItem.SenderMobileNo,
      receiver:'',
      accountno:maxItem.AccountNo,
      ifsc:'',
      bankname:maxItem.BankName,
      amount:total.Amount,
      transactioncode:maxItem.TransactionCode
    }
   

    this.props.history.push({
      pathname: "/printreceiptmerge",
      state: { arr },
    });

    

  }


  checkmerge = (id) => {
    this.setState((prevState) => {
      const { selectedIds } = prevState;

      // Check if the ID already exists in the array
      if (selectedIds.includes(id)) {
        // If yes, remove it (unchecked)
        return { selectedIds: selectedIds.filter((item) => item !== id) };
      } else {
        // If no, add it (checked)
        return { selectedIds: [...selectedIds, id] };
      }
    });
  };





  
  render() {

    const obj = JSON.parse(sessionStorage.getItem("authUser"));
    const sumAmount = this.state.productData.reduce((total, row) => total + row.Amount, 0);
    const sumCharges = this.state.productData.reduce((total, row) => total + row.Charges, 0);
    const sumChargesTaken = this.state.productData.reduce((total, row) => total + row.ChargeTaken, 0);

    const columns = [
      {
        dataField: "action",
        text: "Check",
        formatter: (cellContent, row) => {
          return (
            <input
            type="checkbox"
            //disabled={row.IsRefund? true : false}
              className="btn btn-success btn-xs"
              onClick={() => 
                this.checkmerge(row.F_VoucherH)
              }
            />
            
          );
        },
      },
      {
      dataField: 'TransactionDate',
      text: 'Date/Time',
      sort: true,
      footer: columnData => (
        <div>
         
        </div>
      )
    },

  
    {
      dataField: 'TransactionCode',
      text: 'TransactionCode',
      sort: true,
      footer: columnData => (
        <div>
         
        </div>
      )
    } ,
    {
      dataField: 'AccountHolderName',
      text: 'AccountHolderName',
      sort: true,
      footer: columnData => (
        <div>
         
        </div>
      )
    } ,
    
     {
      dataField: 'SenderMobileNo',
      text: 'SenderMobileNo',
      sort: true,
      footer: columnData => (
        <div>
         
        </div>
      )
    },
    {
      dataField: 'AccountNo',
      text: 'AccountNo',
      sort: true,
      footer: columnData => (
        <div>
         
        </div>
      )
     
    },
    {
      dataField: 'BankName',
      text: 'BankName',
      sort: true,
      footer: columnData => (
        <div>
         
        </div>
      )
    },
    {
      dataField: 'Mode',
      text: 'Mode',
      sort: true,
      footer: columnData => (
        <div>
         
        </div>
      )
    }
    , {
      dataField: 'Amount',
      text: 'Amount',
      sort: true,
      footer: columnData => (
        <div>
         {sumAmount}
        </div>
      )
     
    },

   
    
    {
      dataField: 'Charges',
      text: 'Charges',
      sort: true,
      footer: columnData => (
        <div>
         {sumCharges}
        </div>
      )
     
    },
    
   

     {
      dataField: 'ChargeTaken',
      text: 'ChargeTaken',
      sort: true,
      footer: columnData => (
        <div>
         {sumChargesTaken}
        </div>
      )
     
    },
    {
      dataField: "action",
      text: "Print",
      formatter: (cellContent, row) => {
        return (
          <button
          type="button"
          //disabled={row.IsRefund? true : false}
            className="btn btn-success btn-xs"
            onClick={() => 
              this.btnGoBack_onClick(row.F_VoucherH)
            }
          >
            <i className="mdi mdi-printer font-size-18 mr-3" id="edittooltip"></i>
          </button>
        );
      },
    } 
    
  
  ];

  const defaultSorted = [{
    dataField: 'id',
    order: 'asc'
  }];

  const pageOptions = {
    sizePerPage: 10,
    totalSize: this.state.productData.length, // replace later with size(customers),
    custom: true,
  }

  // Custom Pagination Toggle
  const sizePerPageList = [
    { text: '5', value: 5 },
    { text: '10', value: 10 },
    { text: '15', value: 15 },
    { text: '20', value: 20 },
    { text: '25', value: 25 },
    { text: 'All', value: (this.state.productData).length }];


  // Select All Button operation
  const selectRow = {
    mode: 'checkbox'
  }

  const { SearchBar } = Search;

    return (




     <>

<React.Fragment>
        <div className="page-content">
      
          <Container fluid>
            {/* Render Breadcrumb */}
            <Breadcrumbs
              title={this.breadCrumbTitle}
              breadcrumbItem={this.breadCrumbItem}
            />
            <Row>
              <Col lg="14">
                <Card>
                  <CardBody>
                   
                    <div className="wizard clearfix">
                      <div className="content clearfix">
                            
                            <AvForm className="needs-validation" onValidSubmit={this.btnSave_onClick}>
                         
                                <Row>
                                  <Col lg="12">
                                  
                                

                              
                                    <Row>
                                        <Col sm="1" className="mb-3">
                                          <label htmlFor="firstName" className="col-form-label"> From Date</label>
                                        </Col>
                                        <Col sm="3" className="mb-3">
                                        <AvField name="FromDate" label="" value={this.state.formData.FromDate  ==  undefined ? getCurrentDate() : this.state.formData.FromDate} placeholder="From Date" errorMessage="Select Date " validate={{ required: { value: true } }} type="date"  className="form-control" />
                                        </Col>

                                        <Col sm="1" className="mb-3">
                                          <label htmlFor="DateofBirth" className="col-form-label">To Date</label>
                                        </Col>
                                        <Col sm="3" className="mb-3">
                                        <AvField name="ToDate" label="" value={this.state.formData.ToDate == undefined ? getCurrentDate() : this.state.formData.ToDate} placeholder="To Date" errorMessage="Select Date " validate={{ required: { value: true } }} type="date"  className="form-control" />
                                        </Col>

                                        <Col sm="3" className="mb-3">
                                        <Button
                          type="submit"
                          color="primary"
                        
                          className="mr-1 waves-effect waves-light"
                        >
                          View
                        </Button>
                        
                        <Button
                          type="button"
                          color="primary"
                          style={{marginLeft:10}}
                          onClick={this.exportToExcel}
                          className="mr-1 waves-effect waves-light"
                        >
                          Excel
                        </Button>
                    


                        {/* <Button
                          type="button"
                          color="primary"
                          style={{marginLeft:10}}
                          onClick={this.exportToExcel}
                          className="mr-1 waves-effect waves-light"
                        >
                          Excel
                        </Button> */}
                                          </Col>
                                      
                                    
                                      </Row>
                                    

                                     
                                   

                       
                    
                         </Col>
                         </Row>
                        

                         
                         </AvForm>

                         </div> 



                       



                         </div>

                        
                       
                          </CardBody>
                         </Card>


                         
                         </Col>
                         </Row>

                         <Row>
              <Col className="col-12">
                <Card>
                  <CardBody>
                    <PaginationProvider
                      pagination={paginationFactory({
                        ...pageOptions,
                        sizePerPageList: [
                          { text: '25', value: 25 },
                          { text: '50', value: 50 },
                          { text: '100', value: 100 },
                        ],
                      })}
                      keyField='id'
                      columns={columns}
                      data={this.state.productData}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                          keyField='id'
                          columns={columns}
                          data={this.state.productData}
                          search
                        >
                          {toolkitProps => (
                            <React.Fragment>

                              <Row className="mb-2">
                                <Col md="4">
                                  <div className="search-box me-2 mb-2 d-inline-block">
                                    <div className="position-relative">
                                      <SearchBar
                                        {...toolkitProps.searchProps}
                                      />
                                      <i className="bx bx-search-alt search-icon" />
                                    </div>
                                  </div>
                                </Col>
                              
                              </Row>

                              <Row>
                                <Col xl="12">
                                  <div className="table-responsive">
                                    <BootstrapTable
                                      keyField={"id"}
                                      responsive
                                      bordered={false}
                                      striped={false}
                                      defaultSorted={defaultSorted}
                                     // selectRow={selectRow}
                                      classes={
                                        "table align-middle table-nowrap"
                                      }
                                      headerWrapperClasses={"thead-light"}
                                      {...toolkitProps.baseProps}
                                      {...paginationTableProps}
                                    />

                                  </div>
                                </Col>
                              </Row>

                              <Row className="align-items-md-center mt-30">
                                <Col className="inner-custom-pagination d-flex">
                                  <div className="d-inline">
                                    <SizePerPageDropdownStandalone
                                      {...paginationProps}
                                    />
                                  </div>
                                  <div className="text-md-right ms-auto">
                                    <PaginationListStandalone
                                      {...paginationProps}
                                    />
                                  </div>
                                </Col>
                              </Row>
                            </React.Fragment>
                          )
                          }
                        </ToolkitProvider>
                      )
                      }</PaginationProvider>
                  </CardBody>
                </Card>
              </Col>
              </Row>

              <Row>
              <Col sm="2" className="mb-3">
                                          <label htmlFor="firstName" className="col-form-label">Total Amount -  {sumAmount}</label>
                                        </Col>

                                        <Col sm="2" className="mb-3">
                                          <label htmlFor="firstName" className="col-form-label">Total Charges -  {sumCharges}</label>
                                        </Col>
                                        <Col sm="2" className="mb-3">
                                          <label htmlFor="firstName" className="col-form-label">Total Charge taken -  {sumChargesTaken}</label>
                                        </Col>

              </Row>





                         
                         </Container>

                         </div>
                         </React.Fragment>



  </>
    );
  }
}
export default compose(container)(pageList_FundRequest);
